import InstaBookConfirmationPage from './InstaBookConfirmationPage';

export default InstaBookConfirmationPage;
